import { useState } from 'react';
import { Grid } from '@mui/material';
import { EntryType, ProductType } from 'components/registry/types/api';
import { RegistryProductFiles } from 'components/registry/components/FullInfoCard/components/RegistryProductFiles/RegistryProductFiles';
import { EntryRegistration } from 'components/registry/components/FullInfoCard/components/EntryRegistration/EntryRegistration';
import { RequestMotion } from 'components/registry/components/RequestMotion';
import { useUserDataContext } from 'components/UserDataContext/context';
import { ReportModal } from 'components/ReportModal';
import { ROLES } from 'utils/consts/roles';
import { useGetPermission } from 'utils/hooks/useGetPermission';
import { getIsActual } from 'utils/getIsActual';
import { BackendFileType } from 'api/file/params';
import { ViewFormType } from '../../../../api/params';
import { feedAdditiveApi } from '../../../../api';
import { Information } from './components/Information';

type ViewFormProps = {
  data: ViewFormType;
  updateData: () => void;
  cardLink: string;
  registryLink: string;
  entryType: EntryType;
};

export const ViewForm = ({
  data,
  updateData,
  cardLink,
  registryLink,
  entryType,
}: ViewFormProps) => {
  const { userData } = useUserDataContext();
  const reportCreateDate = new URLSearchParams(window.location.search).get('reportCreateDate');
  const [isActualModalOpen, setIsActualModalOpen] = useState(!!reportCreateDate);

  const permissions = {
    duplicate: useGetPermission(ROLES.feedAdditiveCard.duplicate, userData, true),
    edit: useGetPermission(ROLES.feedAdditiveCard.edit, userData, true),
    remove: useGetPermission(ROLES.feedAdditiveCard.remove, userData, true),
    erul: useGetPermission(ROLES.erul, userData, true),
    elk: useGetPermission(ROLES.elk, userData, true),
  };

  return (
    <Grid container spacing={5}>
      <Grid item xs={12}>
        <Information
          data={data}
          cardLink={cardLink}
          registryLink={registryLink}
          removeMethod={feedAdditiveApi.deleteCard}
          updateData={updateData}
          permissions={permissions}
          userData={userData}
          entryType={entryType}
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <EntryRegistration id={data.id} access={permissions.edit} productType={ProductType.feed} />
      </Grid>
      <Grid item xs={12} lg={6}>
        <RegistryProductFiles
          title="Инструкции по применению"
          modalTitle="инструкции по применению"
          listEmptyText="Нет добавленных инструкций"
          entryId={data.id}
          list={data.product.instructionList}
          removeMethod={feedAdditiveApi.removeInstruction}
          updateMethod={feedAdditiveApi.setInstruction}
          fileType={BackendFileType.INSTRUCTION}
          updateCard={updateData}
          editable={permissions.edit}
        />
      </Grid>
      <Grid item xs={12}>
        <RequestMotion
          id={data.id}
          entryType={entryType}
          productType={ProductType.feed}
          history={data.requestTracingHistoryList}
          updateData={updateData}
          access={permissions.edit}
          regData={data}
          isRegNumberGmoExist={!!data?.product?.gmoList?.length}
        />
      </Grid>

      {reportCreateDate && isActualModalOpen && (
        <ReportModal
          onClose={() => {
            setIsActualModalOpen(false);
          }}
          label="Выписка из государственного реестра кормовых добавок"
          isActual={getIsActual(reportCreateDate, data.updateDate)!}
          reportCreateDate={reportCreateDate}
        />
      )}
    </Grid>
  );
};
